/**
 * The side of the party paying the payment.
 * tag: 40214
 * @readonly
 * @enum {number} (int)
 */
export enum PaymentPaySide {
  /** Buy */
  Buy = 1,
  /** Sell */
  Sell = 2,
}
